<template>
  <v-select
    item-text="text"
    item-value="value"
    :label="label"
    :value="value"
    :items="items"
    clearable
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: String,
    value: String,
    onlyColors: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      const items = [
        { text: this.$t('common.green'), value: 'green' },
        { text: this.$t('common.yellow'), value: 'yellow' },
        { text: this.$t('common.red'), value: 'red' },
      ];

      if (!this.onlyColors) {
        items.unshift({ text: this.$t('common.no'), value: 'no' });
      }

      return items;
    },
  },
};
</script>

<style></style>
